import base from "./base";

export async function checkValidIdForExporting({ token, userId }) {
  return await base.appApi.get("user/valid-status", {
    params: {
      user_id: userId,
    },
    headers: {
      token,
    },
  });
}

export async function createInvoice({ token, formData }) {
  return await base.appApi.post("invoice/", { ...formData, status: "UNVERIFIED" }, {
    headers: {
      token,
    },
  });
}

export async function updateInvoice({ invoiceId, token, formData }) {
  return await base.appApi.put(`invoice/${invoiceId}`, { ...formData, status: "UNVERIFIED" }, {
    headers: {
      token,
    },
  });
}

export async function getInvoice({ invoiceId, token }) {
  return await base.appApi.get("invoice/", {
    params: {
      invoiceId,
    },
    headers: {
      token,
    },
  });
}

export async function deleteInvoice({ invoiceId, token }) {
  return await base.appApi.delete("invoice/", {
    params: {
      invoiceId,
    },
    headers: {
      token,
    },
  });
}

export async function getChildrenId({ userId, token }) {
  return await base.appApi.get("user/child", {
    params: {
      user_id: userId,
    },
    headers: {
      token,
    },
  });
}

export async function verifyUser(token) {
  return await base.apiVerify.post("/", {
    "Content-type": "application/json",
    token,
  });
}
